/**
 * Разбирает варианты заполнения пропуска.
 *
 * @param {string} gap - Варианты, разделённые вертикальной чертой.
 * @param {boolean} markedAnswers - Требует отметки звёздочкой у правильных вариантов.
 * @returns {Array<{text: string, right: boolean}>} Текст без служебных меток и правильность каждого варианта.
 */
const parseGapVariants = (gap, markedAnswers = false) => {
  const variants = gap.split("|");
  // Без отметок в типе 9 допустимы все варианты; при наличии отметок остальные варианты отвлекающие.
  const requiresMark = markedAnswers || variants.some((variant) => variant.includes("*"));
  return variants.map((variant) => ({
    text: variant.replace(/\*/g, ""),
    right: !requiresMark || variant.includes("*"),
  }));
};

export default parseGapVariants;
